import { render, staticRenderFns } from "./NewNav2.vue?vue&type=template&id=67b63927&scoped=true"
import script from "./NewNav2.vue?vue&type=script&lang=js"
export * from "./NewNav2.vue?vue&type=script&lang=js"
import style0 from "./NewNav2.vue?vue&type=style&index=0&id=67b63927&prod&lang=css"
import style1 from "./NewNav2.vue?vue&type=style&index=1&id=67b63927&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b63927",
  null
  
)

export default component.exports